import React from "react";
import {Tooltip} from "@mantine/core";

export const VATIcon = React.memo(({vatStatusId}) => {
    return (
        <Tooltip label="I = VAT Included/Margin | E = VAT Excluded/Net" openDelay={1500}>
            <span className='text-xs flex items-center text-black justify-center rounded-full w-5 h-5 font-bold bg-slate-200'>{vatStatusId === 4 ? 'I' : 'E'}</span>
        </Tooltip>
    )
});